import styled from 'styled-components';

import { scrollbar } from 'common/styles/scrollbar';

import FlexContainer from 'common/components/atoms/FlexContainer';

export const CloneProgressSection = styled(FlexContainer)`
  /* An overlay, not a block in the pane's flow. The tree above is a fixed
     calc(100vh - 110px) scroller, so anything placed after it in flow lands below
     the fold and cannot be scrolled to. Anchored to the bottom of the pane and
     floated over the tree instead, above the header (z-index 5) but well under
     modals (999). */
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background-color: ${props => props.theme.colors.white};
  border-top: 1px solid ${props => props.theme.colors.greyXL};
  box-shadow: 0 -3px 10px 0 rgba(60, 61, 58, 0.18);
  padding: 8px 10px 10px;
  gap: 8px;
`;

export const CloneProgressHeader = styled(FlexContainer)`
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  padding: 2px 0;
`;

export const CloneProgressCount = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${props => props.theme.colors.greyXD};
  background-color: ${props => props.theme.colors.greyXL};
  border-radius: 10px;
  padding: 1px 7px;
  margin-left: 6px;
`;

export const CloneProgressBody = styled(FlexContainer)`
  /* Capped so a long task list never swallows the tree underneath. */
  max-height: 42vh;
  overflow-y: auto;
  gap: 8px;
  ${scrollbar}
`;

export const CloneProgressTitle = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${props => props.theme.colors.greyXD};
`;

export const CloneTaskCard = styled(FlexContainer)`
  border: 1px solid ${props => props.theme.colors.greyXL};
  border-radius: 6px;
  padding: 8px;
  gap: 6px;
`;

export const CloneTaskHeader = styled(FlexContainer)`
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const CloneTaskDismiss = styled.button`
  /* Lets a finished task be cleared from the panel, and a running one be given up on.
     Without this the list could only ever grow. */
  border: none;
  background: none;
  cursor: pointer;
  padding: 0 2px;
  margin-left: 8px;
  font-size: 16px;
  line-height: 1;
  color: ${props => props.theme.colors.greyD};

  &:hover {
    color: ${props => props.theme.colors.greyXD};
  }
`;

export const CloneTaskLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.theme.colors.black};
`;

export const CloneTaskMeta = styled.span`
  font-size: 11px;
  color: ${props => props.theme.colors.greyXD};
`;

export const EmptyCloneState = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.greyXD};
`;

export const MachineRows = styled(FlexContainer)`
  border: 1px solid ${props => props.theme.colors.greyXL};
  border-radius: 6px;
  max-height: 160px;
  overflow-y: auto;
  ${scrollbar}
`;

export const MachineRow = styled(FlexContainer)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px solid ${props => props.theme.colors.greyXL};

  &:last-child {
    border-bottom: none;
  }
`;

export const MachineName = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.theme.colors.black};
`;
